/**
 * <ReferralModal> — referral share modal shell (template, L0.1).
 *
 * Wraps `<ReferralShare>` in the DS `<Modal>`. Pure composition — effects stay injected.
 */
import { Modal } from "../../molecules/Modal"
import { ReferralShare, type ReferralShareProps } from "../../organisms/ReferralShare"

export type ReferralModalProps = ReferralShareProps & {
    visible: boolean
    onClose: () => void
    testID?: string
}

export function ReferralModal(props: ReferralModalProps) {
    const { visible, onClose, testID, ...shareProps } = props

    return (
        <Modal
            visible={visible}
            onClose={onClose}
            title="Parrainage"
            dismissable
            fitContent
            scrollable={false}
            testID={testID}
        >
            <ReferralShare {...shareProps} />
        </Modal>
    )
}
